import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import Button from '@dashboard/components/Button';
import Spinner from '@dashboard/components/Spinner';

const FormSubmit = ({ children, align = 'start' }) => {
  return (
    <div
      className={clsx('flex flex-row items-baseline mt-8 gap-x-4', {
        'justify-start': align === 'start',
        'justify-end': align === 'end',
      })}
    >
      {children}
    </div>
  );
};

const FORM_SUBMIT_STATES = {
  INITIAL: 'initial',
  SUBMITTING: 'submitting',
  SUBMITTED: 'submitted',
};

// initial, submitting, submitted, error
const FormSubmitButton = ({
  children,
  appearance = 'primary',
  onClick,
  type = 'submit',
  size = 'base',
  isSubmitting,
  isValidating,
  hasError,
  submitSpinner = true,
  disabled,
}) => {
  const [state, setState] = useState(FORM_SUBMIT_STATES.INITIAL);

  useEffect(() => {
    if (state === FORM_SUBMIT_STATES.INITIAL && (isSubmitting || isValidating)) {
      return setState(FORM_SUBMIT_STATES.SUBMITTING);
    }

    if (state === FORM_SUBMIT_STATES.SUBMITTING && !isSubmitting && !hasError) {
      setState(FORM_SUBMIT_STATES.SUBMITTED);

      window.setTimeout(() => {
        setState(FORM_SUBMIT_STATES.INITIAL);
      }, 2000);

      return;
    }

    if (state === FORM_SUBMIT_STATES.SUBMITTING && !isSubmitting) {
      setState(FORM_SUBMIT_STATES.INITIAL);
    }
  }, [hasError, isSubmitting, isValidating]);

  const isDisabled = disabled || state === FORM_SUBMIT_STATES.SUBMITTING || isValidating;

  return (
    <Button type={type} appearance={appearance} onClick={onClick} disabled={isDisabled} size={size}>
      {state === FORM_SUBMIT_STATES.INITIAL && children}

      {state === FORM_SUBMIT_STATES.SUBMITTING && (
        <>
          {children}
          {submitSpinner && <Spinner className="ml-2 h-5 w-5 !text-current" />}
        </>
      )}

      {state === FORM_SUBMIT_STATES.SUBMITTED && children}
    </Button>
  );
};

FormSubmit.Button = FormSubmitButton;

const FormSubmitState = ({ visible }) => {
  if (!visible) return '';

  return <div className="text-gray-600 text-sm">Changes not saved</div>;
};

FormSubmit.State = FormSubmitState;

const FormSubmitCancel = ({
  onClick,
  appearance = 'secondary',
  size = 'base',
  children = 'Cancel',
}) => {
  return (
    <Button appearance={appearance} onClick={onClick} size={size}>
      {children}
    </Button>
  );
};

FormSubmit.Cancel = FormSubmitCancel;

export default FormSubmit;
